export const EvidenceActionTypes = {
    REVIEW: 'REVIEW',
    EDIT: 'EDIT',
    VIEW: 'VIEW',
};

export const EvidenceActionLabels = {
    [EvidenceActionTypes.REVIEW]: 'Review',
    [EvidenceActionTypes.EDIT]: 'Edit',
    [EvidenceActionTypes.VIEW]: 'View',
};

export const getEvidenceActionLabel = (actionType) => {
    return EvidenceActionLabels[actionType] || 'Unknown Action';
};
